export const inputsInState = ['newAddress', 'commune', 'comment'];

export const makeInitialState = () => ({
  newAddress: {
    value: '',
    error: false,
    message: '',
    helper: 'Dirección, número, depto/casa/oficina',
    inputAdornment: '',
    label: 'Nueva dirección',
    required: true,
    success: false,
  },
  commune: {
    value: '',
    error: false,
    message: '',
    helper: '',
    inputAdornment: '',
    label: 'Comuna',
    required: false,
    success: false,
    disabled: true,
  },
  comment: {
    value: '',
    error: false,
    message: '',
    helper: '0/250',
    inputAdornment: '',
    label: 'Escribir un comentario',
    required: true,
    success: false,
    textArea: true,
  },
});
